import { DriveFolderUpload } from "@mui/icons-material";
import PropTypes from "prop-types";

import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import { useDocumentListStore } from "../../../../../../../modules/Documents/ViewDocuments/hooks/useDocumentListStore";
import ActionButton from "../ui/ActionButton";

const UploadDocument = ({ permission, docNeedsType, setUploadDocument, setViewDocuments }) => {
  const { setIsUploadModalOpen } = useDocumentListStore();

  const openUploadModal = () => {
    setIsUploadModalOpen(true);
  };

  return (
    <PermissionWrapper permission={permission}>
      <ActionButton
        title={"Upload Document to Case"}
        icon={<DriveFolderUpload fontSize="18" />}
        action={() => openUploadModal()}
      />
    </PermissionWrapper>
  );
};

export default UploadDocument;

UploadDocument.propTypes = {
  permission: PropTypes.any,
  docNeedsType: PropTypes.any,
  setUploadDocument: PropTypes.func,
  setViewDocuments: PropTypes.func,
};
